import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks';
import { transferState, listTransferFiles } from '../transferSlice';
import TransferSdk from "@smash-sdk/transfer/ejs/07-2022";

export const useTransferFiles = (): [boolean, TransferSdk.ListTransferFilesOutput['files'], string[], string?] => {
    const dispatch = useAppDispatch();
    const { transferDetails, transferFiles } = useAppSelector(transferState);
    useEffect(() => {
        if (!transferFiles.isLoading && !transferFiles.isSuccess && transferDetails.transfer) {
            dispatch(listTransferFiles({ transferId: transferDetails.transfer.id, hasPrevious: false }));
        }
    }, [transferFiles.files, transferDetails.transfer, transferFiles.isLoading, transferFiles.isSuccess, dispatch]);

    return [transferFiles.isLoading, transferFiles.files, transferFiles.previous, transferFiles.next]
}